"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _background = _interopRequireDefault(require("../images/minduplifter/background.png"));

var _stitches = require("../stitches.config");

var images = {};
var theme = (0, _stitches.createTheme)('minduplifter', {
  background: {
    image: "url(".concat(_background.default, ")")
  }
});
var _default = {
  images: images,
  theme: theme
};
exports.default = _default;